<template>
  <section class="menus-detail-container">
    <base-header
      v-bind="headers"
    />
    <base-form
      ref="form"
      v-bind="form"
      v-on:handleConfirm="handleConfirm"
      v-on:handleConfirmSave="handleConfirmSave"
    >
      <template #fileList="scope">
        <div class="apis-list-wrap">
          <el-button type="primary" :disabled="scope.form[scope.item.prop].length > 0 ? true : false" size="small" width="82px" @click="handleShowUploadDialog">
            选择文件
          </el-button>
          <div class="apis-list">
            <template v-for="(item, index) in scope.form[scope.item.prop]">
              <span class="api-item jee-hover-border-important jee-hover-color" :key="index">
                <span>{{item.fileName}}</span>
                <i class="el-icon-close" @click="()=>handleDeleteFile()"></i>
              </span>
            </template>
          </div>
        </div>
      </template>
    </base-form>
    <form-dialog
      title="上传"
      ref="uploadDialog"
      :loading="uploadFormLoading"
      :form="uploadForm"
      :rules="uploadRules"
      :buttons="uploadButtons"
      :formItems="uploadFormItems"
      @handleConfirm="handleConfirmAdd"
      @beforeUpload="beforeUpload"
    ></form-dialog>
  </section>
</template>
<script>
import baseHeader from '@/components/mixins/baseHeader'
import baseForm from '@/components/mixins/baseForm'
import formDialog from '@/components/mixins/formDialog'
import msgDialog from '@/components/mixins/msgDialog'

export default {
  name: 'extcontentCheck',
  mixins: [baseHeader, baseForm, msgDialog, formDialog],
  data () {
    return {
      uploadFormLoading: false,
      uploadForm: {
        'fileName': '',
        'file': ''
      },
      uploadRules: {
        fileName: [
          this.$rules.required('请选择需要上传的文件')
        ]
      },
      uploadButtons: [
        {
          text: '确定',
          type: 'Submit'
        }
      ],
      uploadFormItems: [
        {
          prop: 'fileName',
          type: 'upload',
          label: '选择文件',
          readonly: true,
          appendText: '选择文件',
          fileList: [],
          accept: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        }
      ],
      form: {
        api: 'fetchUserCenterContentDetail',
        params: {
          id: ''
        },
        form: {
          id: '',
          title: '',
          innovationContent: '',
          fileList: [],
          remark: ''
        },
        formItems: [
          {
            prop: 'title',
            label: '稿件名称：',
            maxlength: 50,
            placeholder: '不超过50字'
          },
          {
            prop: 'fileList',
            label: '稿件上传：',
            type: 'slot'
          },
          {
            type: 'textarea',
            prop: 'innovationContent',
            label: '文章创新点：',
            maxlength: 200,
            placeholder: '不超过200字'
          },
          {
            type: 'textarea',
            prop: 'remark',
            label: '备注说明：',
            maxlength: 200,
            placeholder: '不超过200字'
          }
        ],
        rules: {
          title: [
            this.$rules.required()
          ],
          fileList: [
            this.$rules.required()
          ]
        },
        submitBtns: [
          {
            text: '存为草稿',
            subType: 'Save',
            notDisabled: true
          },
          {
            text: '投稿',
            subType: 'submit',
            notDisabled: true
          }
        ]
      },
      headers: {
        buttons: [],
        title: '编辑投稿',
        showAlertIcon: true,
        content: '稿件初审一般需要1-3个月时间。一经录用，作者即将注册章程所载著作财产权让予本编委会。'
      }
    }
  },
  inject: ['removeTab'],
  methods: {
    // 保存提交
    handleConfirm (data) {
      this.form.loading = true
      let api = 'fetchUserCenterContentUpdate'
      data.attachment = data.fileList.length > 0 ? data.fileList[0].fileId : ''
      data.type = 'POST'
      this.$request[api](data).then(res => {
        this.hideFormLoading()
        if (res.code === 200) {
          this.$refs.form.resetFields()
          this.removeTab(this.$route.fullPath)
          this.$router.replace({ name: 'userCenterContentIndex' })
        }
      }).catch(this.hideFormLoading)
    },
    handleConfirmSave (data) {
      this.form.loading = true
      let api = 'fetchUserCenterContentUpdate'
      data.attachment = data.fileList.length > 0 ? data.fileList[0].fileId : ''
      data.type = 'SAVE_DRAFT'
      this.$request[api](data).then(res => {
        this.hideFormLoading()
        if (res.code === 200) {
          this.$refs.form.resetFields()
          this.removeTab(this.$route.fullPath)
          this.$router.replace({ name: 'userCenterContentIndex' })
        }
      }).catch(this.hideFormLoading)
    },
    fetchFormCallBack (res) {
      if (res.code === 200) {
        res.data.hidden = !res.data.hidden
        this.$set(this.form, 'form', {
          id: res.data.id,
          title: res.data.title,
          innovationContent: res.data.innovationContent,
          fileList: [{
            fileName: res.data.attachmentName,
            fileId: res.data.attachment
          }],
          remark: res.data.remark
        })
      }
    },
    handleShowUploadDialog () {
      this.$refs.uploadDialog.showDialog()
    },
    // 上传
    beforeUpload (file, type) {
      this.uploadForm.fileName = file.name
      this.uploadForm.file = file
      this.uploadForm.type = type
    },
    handleConfirmAdd (data, btn) {
      const param = new FormData() // 创建form对象
      param.append('uploadFile', data.file.raw, data.fileName) // 通过append向form对象添加数据
      // param.append('spaceId', this.list.params.id) // 添加form表单中其他数据
      // param.append('typeStr', data.type) // 添加form表单中其他数据
      // param.append('addToRes', true) // 添加form表单中其他数据
      this.$request.fetchUpload(param).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '上传成功',
            type: 'success'
          })
          let arr = []
          arr.push({
            fileName: data.fileName,
            fileId: res.data.resourceId
          })
          this.form.form.fileList = arr
        }
      })
    },
    handleDeleteFile () {
      this.form.form.fileList = []
    }
  },
  mounted () {
    const { id } = this.$route.query
    this.form.params.id = id
    this.fetchFormApi()
  },
  activated () {
    const { id } = this.$route.query
    if (id) {
      this.form.params.id = id
      this.fetchFormApi()
    }
  }
}
</script>
<style lang="scss" scoped>
.menus-detail-container{
  .apis-list{
    color: #666666;
    display: flex;
    flex-direction: column;
    width: 414px;
    .api-item{
      font-size: 14px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      line-height: 22px;
      padding: 10px 30px 10px 10px;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      margin-top: 10px;
      position: relative;
      span {
        word-break: break-all;
      }
      span:last-of-type{
        flex: 1;
      }
      i{
        cursor: pointer;
        position: absolute;
        right: 10px;
      }
    }
  }
  .status-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border: solid 1px #e5e5e5;
    .status-item {
      display: flex;
      align-items: center;
      padding: 20px;
      box-sizing: border-box;
      span {
        display: block;
        text-align: left;
      }
      .text {
        line-height: 26px;
        color:#5f5d5d;
      }
      .title {
        color: #000;
      }
    }
    .status-icon {
      margin-left: 20px;
    }
  }
  .tip-header {
    height: 40px;
    background:#f2fbfc;
    border:1px solid #1fc6df;
    border-radius:4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    margin-right: 40px;
    margin-bottom: 40px;
    box-sizing: border-box;
    .title {
      font-size:14px;
      color:#000000;
    }
    .button {

    }
  }
}
</style>
